import DesShareLibraryToTeamsViewModel from 'viewmodel/DesShareLibraryToTeamsViewModel'
import { DesBaseCatalogAcc } from '../utils/des-base-catalog-acc';

export default class DesShareLibraryToTeams extends DesBaseCatalogAcc {
    constructor() {
        super(DesShareLibraryToTeamsViewModel);
    }

    get libraryId() {
        return this.getAttribute('library-id') || this.getAttribute('libraryid');
    }

    get emailTemplateId() {
        return this.getAttribute('email-template-id') || this.getAttribute('emailtemplateid');
    }

    get emailTemplateParams() {
        return this.getAttribute('email-template-params') || this.getAttribute('emailtemplateparams');
    }

    get teamId() {
        return this.getAttribute('teamid') || this.getAttribute('team-id');
    }

    get locale() {
        return this.getAttribute('locale') || 'en_US';
    }

    getProps() {
        return {
            libraryid: this.libraryId,
            teamid: this.teamId,
            emailtemplateparams: this.emailTemplateParams,
            emailtemplateid: this.emailTemplateId
        };
    }

    static get observedAttributes() {
        return [...DesBaseCatalogAcc.observedAttributes, 'locale', 'library-id', 'libraryid',
            'email-template-id', 'emailtemplateid',
            'email-template-params', 'emailtemplateparams',
            'teamid','team-id'];
    }
}

if (!window.customElements.get('des-share-library-to-teams')) {
    window.customElements.define('des-share-library-to-teams', DesShareLibraryToTeams);
}
